import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export interface GetExperienceForCandidateResponse extends BackendResponse {
  items: Experience[];
}

export const getExperienceForCandidate =
  withNextApi<GetExperienceForCandidateResponse>(
    "/cvp/CvpGetExperienceForCandidate"
  );

export interface Experience {
  id: number;
  idCandidate: number;
  fromDate: string | null;
  toDate: string | null;
  idCustomer: number;
  firm: string;
  position: string;
  references: string;
  industry: string;
  industryType: number;
  level: number;
  comment: string;
  hide: boolean;
}
